import http from "@/settings/apiSettings"

function toDateParam(d: Date | string): string {
    if (typeof d === 'string') return d
    return d.toISOString().slice(0, 10)
}

class COM_RaportVanzariService {
    getRaportAgenti(dataStart: Date | string, dataEnd: Date | string, tipDocumentId?: string): Promise<any> {
        const params = new URLSearchParams({ dataStart: toDateParam(dataStart), dataEnd: toDateParam(dataEnd) });
        if (tipDocumentId) params.append('tipDocumentId', tipDocumentId);
        return http.clientComercial.get(`/COM_RaportVanzari/GetRaportAgenti?${params}`);
    }

    getDetaliiAgent(agentId: string, dataStart: Date | string, dataEnd: Date | string, tipDocumentId?: string): Promise<any> {
        const params = new URLSearchParams({ agentId, dataStart: toDateParam(dataStart), dataEnd: toDateParam(dataEnd) });
        if (tipDocumentId) params.append('tipDocumentId', tipDocumentId);
        return http.clientComercial.get(`/COM_RaportVanzari/GetDetaliiAgent?${params}`);
    }
}

export default new COM_RaportVanzariService();
